export class MaterialTransfer {
    // AKA equipement transfer

    id!: string
    material!: string
    location!: string
    quantity!: number
    date!: Date
    requestedByHrRef!: number | undefined
    userHrRef!: number

    requestedByName!: string
    userName!: string
    validationMessage!: string
    isToolInstance!: boolean
    sourceLocation!: string
    totalPrice!: number
}
